// src/App.js
import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { StripeProvider } from './contexts/StripeContext';
import { Elements } from '@stripe/react-stripe-js';
import stripePromise from './config/stripe';
import ProtectedRoute from './components/auth/ProtectedRoute';
import SubscriptionGuard from './components/auth/SubscriptionGuard';
import DocketGenie from './pages/DocketGenie';
import LandingPage from './pages/LandingPage';
import SubscriptionManagement from './pages/SubscriptionManagement';
import Reports from './pages/Reports';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ForgotPassword from './components/auth/ForgotPassword';
import ProfileCompletion from './components/auth/ProfileCompletion';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';

// Clean up memory when component unmounts
function App() {
  React.useEffect(() => {
    return () => {
      // Force garbage collection when possible
      if (global.gc) {
        global.gc();
      }
    };
  }, []);

  // Check if authentication should be bypassed for development
  const skipAuth = process.env.REACT_APP_SKIP_AUTH === 'true';

  return (
    <AuthProvider>
      <StripeProvider>
        <Elements stripe={stripePromise}>
          <Router>
            <div className="App">
              <Routes>
                <Route
                  path="/"
                  element={
                    skipAuth ? <Navigate to="/app" replace /> : <LandingPage />
                  }
                />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route
                  path="/complete-profile"
                  element={<ProfileCompletion />}
                />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route
                  path="/app"
                  element={
                    <ProtectedRoute>
                      <SubscriptionGuard>
                        <DocketGenie />
                      </SubscriptionGuard>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/reports"
                  element={
                    <ProtectedRoute>
                      <SubscriptionGuard>
                        <Reports />
                      </SubscriptionGuard>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/subscription"
                  element={
                    <ProtectedRoute>
                      <SubscriptionManagement />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </div>
          </Router>
        </Elements>
      </StripeProvider>
    </AuthProvider>
  );
}

export default App;
